import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "1fr 20px",
    gridTemplateRows: "24px 1fr",
    gridTemplateAreas: `
      "wrap close"
      "subtitle subtitle"
    `,
    padding: "16px 16px 0 16px",
    [theme.breakpoints.up("md")]: {
      padding: "24px 24px 0 24px",
    },
  },
  wrap: {
    display: "inline-grid",
    gridArea: "wrap",
  },
  image: {
    position: "relative",
  },
  title: {
    display: "block",
    margin: 0,
  },
  close: {
    gridArea: "close",
    position: "relative",
  },
  closeIcon: {
    position: "absolute",
    width: "20px !important",
    height: "20px !important",
    "& svg": {
      width: 20,
      height: 20,
      color: theme.palette.grey[700],
    },
  },
  subtitle: {
    gridArea: "subtitle",
    marginTop: 8,
    fontSize: 14,
    lineHeight: "20px",
    color: theme.palette.grey[700],
  },
}));
